<template>
    <b-card no-body :class="cardBgVariant" style="height: 220px">
        <b-card-body class="d-flex flex-column pb-0">
            <div class="d-flex justify-content-between">
                <h3 class="mb-0">{{ headerCardStat }}</h3>
            </div>
            <p class="subheader mb-0">{{ subheader }}{{ year > 0 ? ` с ${year} г.` : '' }}</p>
            <div class="mt-auto">
                <slot></slot>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CardSmall',
  props: {
    subheader: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'primary'
    },
    dataType: {
      type: String,
      default() {
        return ''
      }
    },
    year: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  methods: {
    findYearWithData(data) {
      return Math.max.apply(null, data.map((st) => st.year))
    }
  },
  computed: {
    cardBgVariant() {
      return `bg-${this.variant}`
    },
    headerCardStat() {
      const yearCount = this.findYearWithData(this.countSchoolsDOClasses)
      if (this.dataType === 'studentsToPartners') {
        return this.studentsToPartnersForYear
          .reduce((prev, curr) => (curr.year >= this.year ? prev + curr.count : prev), 0) || ''
      } if (this.dataType === 'countSchools') {
        return this.countSchoolsDOClasses.find((p) => p.year
          === yearCount).countSchools
      } if (this.dataType === 'countClasses') {
        return this.countSchoolsDOClasses.find((p) => p.year
          === yearCount).countClasses
      } if (this.dataType === 'countDO') {
        return this.countSchoolsDOClasses.find((p) => p.year
          === yearCount).countDO
      }
      return ''
    },
    ...mapGetters({
      studentsToPartnersForYear: 'statistics/getStatsStudentsToPartners',
      countSchoolsDOClasses: 'statistics/getStatsCountSchoolsDOClasses',
      orgs: 'dicts/getOrganizations'
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
